// extracted by mini-css-extract-plugin
module.exports = {"page":"_1HtIwYlfHH5FOEq86fJMs2","pageInner":"_3dNt8IdvbANg_cNzFiv30S","pageInnerLandscape":"_8UK4-42Si9sXeAejtYF98"};